import { ICreativeFormData } from '@/Interfaces/Creatives/Creative.interface';
import { getFieldErrorProps } from '@/helpers/form';
import { URL_RULES } from '@/utils/validationRules';
import { Add, Clear } from '@mui/icons-material';
import { Button, FormLabel, IconButton, TextField } from '@mui/material';
import { memo, useCallback, useState } from 'react';
import { Control, Controller } from 'react-hook-form';

interface IProps {
  pixels: string[];
  handlePixelsChange: (pixels: string[]) => void;
  control: Control<ICreativeFormData, any>;
  disabled?: boolean;
}

const PixelsInput = memo(({ pixels, handlePixelsChange, control, disabled }: IProps) => {
  const [autoFocusLastInput, setAutoFocusLastInput] = useState(false);

  const handleAddPixel = useCallback(() => {
    handlePixelsChange([...pixels, 'https://']);
    setAutoFocusLastInput(true);
  }, [handlePixelsChange, pixels]);

  const handleRemoveInput = useCallback(
    (index: number) => {
      handlePixelsChange(pixels.filter((_, i) => i !== index));
    },
    [handlePixelsChange, pixels],
  );

  return (
    <div>
      <FormLabel className='text-sm font-semibold mb-2' htmlFor='pixels-input'>
        Pixels
      </FormLabel>
      {pixels.map((_, index) => (
        <Controller
          key={index}
          name={`pixels.${index}`}
          control={control}
          rules={URL_RULES}
          disabled={disabled}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              id='pixels-input'
              variant='outlined'
              fullWidth
              sx={{ mb: 1 }}
              disabled={disabled}
              autoFocus={index === pixels.length - 1 && autoFocusLastInput}
              {...getFieldErrorProps(fieldState)}
              slotProps={{
                input: {
                  endAdornment: (
                    <IconButton onClick={() => handleRemoveInput(index)} disabled={disabled}>
                      <Clear sx={{ width: 20, height: 20 }} />
                    </IconButton>
                  ),
                },
              }}
            />
          )}
        />
      ))}
      <Button variant='contained' onClick={handleAddPixel} disabled={disabled}>
        <Add sx={{ width: 20, height: 20, marginRight: '4px' }} />
        <span>Add 3rd Party Impression Pixel</span>
      </Button>
    </div>
  );
});

export default PixelsInput;
